<template>
  <section class="content-padding-gray">
    <Header></Header>
    <router-view/>
  </section>
</template>

<script>
import Header from './components/Header'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'ProfessionalView',
  components: { Header },
  computed: {
    ...mapState({
      professional: state => state.auth.professional,
      tokenProfessional: state => state.auth.tokenProfessional
    })
  },
  methods: {
    async checkAuth () {
      if (!this.professional) {
        this.$router.replace({ name: 'Professional Login', query: { redirect_to: 'Professional With Holding Tax' } })
      }
      const headers = { 'Authorization': `Bearer ${this.tokenProfessional}` }
      const { data } = await axios.post('/professional/' + this.professional.id + '/me', {
        access_token: this.tokenProfessional
      }, {
        headers
      })
      if (data.error) {
        this.$swal({ text: data.message, type: 'error' })
        this.$store.dispatch('auth/LOGOUT_PROFESSIONAL')
        this.$router.replace({ name: 'Professional Login', query: { redirect_to: 'Professional With Holding Tax' } })
      }
    }
  },
  created () {
    this.checkAuth()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalView.vue